import { useCurrentUser } from 'hooks/auth';
import { useIsCurrentUserOmni } from 'hooks/auth/useIsCurrentUserOmni';
import { useIsPaidTalentAccount } from 'hooks/talents/useTalentAccountType';
import React from 'react';

import { PendingVerificationTalentContent } from './PendingVerificationTalentContent';

interface MiddleContentProps {}

export const MiddleContent = (props: MiddleContentProps) => {
  const { data } = useCurrentUser();
  const isOmniAccount = useIsCurrentUserOmni();
  const isPaidTalent = useIsPaidTalentAccount();
  const talent = data?.currentTalent;

  if (!!talent && !isPaidTalent && !isOmniAccount) {
    return <PendingVerificationTalentContent />;
  }

  return <div></div>;
};
